var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgTrips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1349.6 1097.3",
    style: {
      enableBackground: "new 0 0 1349.6 1097.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.9,139h143.8c2.9-6.1,5.4-12.6,7.3-19.4c5.1-18.1,5-41.2-9.6-60.6c-16.8-22.3-47-30.9-68.1-25.6 c-16.9,4.2-29.3,15.2-40.4,27.3C135.2,80.3,123.7,107.8,121.9,139z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M862.8,72.8c-139-23.2-233,9.4-354.3,81.2c-78.4,46.4-146.7,110.3-230.7,145.5c-64.7,27.1-138.4,37.1-192.7,81.3 C-34.7,480,5.5,669.2,123.3,753.8c40.3,31.3,90.7,57.2,107.5,105.5c12.5,36,2.8,77.2,17,112.5c58.9,121.4,292.7,74.8,395.1,34 c57.2-23.2,122.6-47.5,184.2-53.1c75.4-6.9,139.1,19.7,214.8,17.2c192.6-8.9,304-189.2,291.9-363.4c-1.6-59.2-15.2-115.9-43.4-167.8 c-55.1-101.4-102.1-93.5-149.8-189.5C1074.9,117.2,955.4,88.2,862.8,72.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.2,146c-11.1,54.3-55,87.8-110.4,87.8S118.5,185,122,129.6c3.8-60.2,37.4-96.6,92.9-96.6S316.5,90.7,305.2,146z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTrips);
export default __webpack_public_path__ + "static/media/bg_trips.1dcb8a9fc1fbf75d2eecfd882ec72027.svg";
export { ForwardRef as ReactComponent };